import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NimmstaCommonsModuleConfiguration } from '../nimmsta-commons-module.config';
import Keycloak from 'keycloak-js';

@Injectable()
export class OrganizationInterceptor implements HttpInterceptor {
  private keycloak = inject(Keycloak);
  private authService = inject(AuthService);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Check if keycloak is initialized and the user is authenticated
    if (!this.keycloak.didInitialize || !this.keycloak.authenticated) {
      return next.handle(req);
    }
    // Check if the request is for a protected API
    const apiUrls = Object.entries(this.configuration.apiUrls)
      .filter(([urlKey]) => urlKey !== 'auth')
      .map(([, url]) => url)
      .filter((url): url is string => !!url);
    const shouldIntercept = apiUrls.some((apiUrl) =>
      req.url.startsWith(apiUrl),
    );
    if (!shouldIntercept) {
      return next.handle(req);
    }

    const organizationId = this.authService.getActingOrganizationId();
    if (organizationId) {
      const modifiedReq = req.clone({
        setHeaders: {
          'X-Effective-Organization-Id': organizationId,
        },
      });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
